import Head from 'next/head'

import Box from '@totallymoney/ui/components/Box'
import Card from '@totallymoney/ui/components/Card'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'
import theme from '@totallymoney/ui/theme'

import NextLinkWithChevron from '@components/NextLinkWithChevron'

import { creditCardTypes } from './lib/creditCardTypes'

const UnscoredCategoryPageTypesSection = () => (
    <>
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'ItemList',
                        name: 'Types of credit card',
                        itemListElement: creditCardTypes.map(
                            ({ link, heading }, i) => ({
                                '@type': 'ListItem',
                                position: i + 1,
                                item: {
                                    '@type': 'WebPage',
                                    headline: heading,
                                    url: `${process.env.BASE_FORM_URL}${link.href}`,
                                },
                            })
                        ),
                    }),
                }}
            />
        </Head>

        <Box gridColumn="1/13">
            <Box
                display="grid"
                gridTemplateColumns={[
                    '1fr',
                    'repeat(2, 1fr)',
                    'repeat(3, 1fr)',
                ]}
                gridGap="space30"
            >
                {creditCardTypes.map(
                    ({ icon, heading, text, link: { href, linkText } }, i) => (
                        <Card
                            height="100%"
                            hasShadow={false}
                            p="space30"
                            key={`${heading}-${i}`}
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                        >
                            <Stack space="space20" mb="space20" flex={1}>
                                <Icon
                                    color={theme.scaleLevel100}
                                    icon={icon}
                                    size={48}
                                />

                                <Heading variant="60">{heading}</Heading>

                                <Text color="light" variant="100">
                                    {text}
                                </Text>
                            </Stack>

                            <Box>
                                <NextLinkWithChevron
                                    href={href}
                                    text={linkText}
                                />
                            </Box>
                        </Card>
                    )
                )}
            </Box>
        </Box>
    </>
)

export default UnscoredCategoryPageTypesSection
